import React from 'react'

const TabMenu = (props) => {
  return (
    <div className={'mb-6 grid text-sm md:text-base grid-cols-' + props.options.length}>
      {
        props.options.map((option, index) => (
          <button key={index} className={'bg-white/50 text-center py-3 border-b-4 ' + (props.active === index ? 'border-purple-400 text-purple-600' : 'border-transparent')} onClick={() => props.setActive(index)}>{option}</button>
        ))
      }
    </div>
  )
}

export default TabMenu